import { render, staticRenderFns } from "./MarketingSpendDetailChannelTouchpoint.vue?vue&type=template&id=71817e81&"
import script from "./MarketingSpendDetailChannelTouchpoint.vue?vue&type=script&lang=js&"
export * from "./MarketingSpendDetailChannelTouchpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports